import { useEffect } from "react";
import { useSelector } from "react-redux";
import AuthService from "services/auth";

const POLL_INTERVAL_MS = 30000;

const SessionMonitor = () => {
    const isLoggedIn = useSelector(state => state.auth.isLoggedIn);

    useEffect(() => {
        if (!isLoggedIn) return;

        const interval = setInterval(() => {
            AuthService.checkSession().catch(() => {
                // 401 responses are handled by the HTTP interceptor
            });
        }, POLL_INTERVAL_MS);

        return () => clearInterval(interval);
    }, [isLoggedIn]);

    return null;
};

export default SessionMonitor;
